export const theme = {
  primary: "#5299DC",
  white: "#FFFFFF",
  centered: { alignItems: "center", justifyContent: "center", display: "flex" },
};
